import React from 'react';

import _get from 'lodash/get';

import { pageNames } from '@atc/bonnet-paths';
import { useFeatures } from '@atc/features';

import { PageSection } from 'reaxl';

import vdpAdsDuck from '@/ducks/vdp/vdpAdsDuck.js';

import AtcAdSlot from '@/containers/AtcAdSlot';
import DisableAdsFeatureFlag from '@/containers/global/DisableAdsFeatureFlag';

import LazyComponent from '@/components/LazyComponent';

const { VEHICLE_DETAILS } = pageNames;

function LeaderBoardAdSlotContainer({
    isInColumn,
}) {
    const {
        ads: [, { adSlotParams }],
    } = useFeatures([
        'ads',
    ]);

    adSlotParams.lazyLoadingBottomOffset = -20;
    adSlotParams.lazyLoadingTopOffset = -20;
    adSlotParams.showPlaceholder = true;
    const width = _get(adSlotParams, 'size[0][0]', 0);
    const height = _get(adSlotParams, 'size[0][1]', 0);

    return (
        <DisableAdsFeatureFlag>
            <LazyComponent
                key="leaderboard_lazy"
                height={height}
                width={width}
            >
                {isInColumn ? (
                    <AtcAdSlot
                        className="margin-vertical-4 margin-vertical-md-5"
                        adSelector={vdpAdsDuck.selectors.getDuckState}
                        pageName={VEHICLE_DETAILS}
                        preserveSpace
                        {...adSlotParams}
                    />
                ) : (
                    <PageSection
                        className="col-lg-8"
                        uiContext="section-2"
                        alignment="left"
                    >
                        <AtcAdSlot
                            adSelector={vdpAdsDuck.selectors.getDuckState}
                            pageName={VEHICLE_DETAILS}
                            {...adSlotParams}
                        />
                    </PageSection>
                )}

            </LazyComponent>
        </DisableAdsFeatureFlag>
    );
}

export default React.memo(LeaderBoardAdSlotContainer);
